// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-719efe18]{width:100%}.badge-container[data-v-719efe18]{display:flex;justify-content:center;align-items:center}.ticket-row[data-v-719efe18]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
